import {Tooltip} from "antd";
import {forwardRef} from "react";
import type {AppTooltipProps} from "./Tooltip.types";
import {getOverlayClassNames} from "./Tooltip.utils";

export const AppTooltip = forwardRef<typeof Tooltip, AppTooltipProps>((props, ref) => {
  const overlayClassNames = getOverlayClassNames(props);
  return <Tooltip {...props} ref={ref} overlayClassName={overlayClassNames}/>;
});